module.exports = __webpack_public_path__ + "static/img/sec2-img04@tw.660b602.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec2-img04@tw.png
// module id = aCF5
// module chunks = 0